import { render, staticRenderFns } from "./cn-dashboard.vue?vue&type=template&id=b1d994a4&scoped=true&"
import script from "./cn-dashboard.vue?vue&type=script&lang=js&"
export * from "./cn-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./cn-dashboard.vue?vue&type=style&index=0&id=b1d994a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d994a4",
  null
  
)

export default component.exports